export default {
  computed: {
    $userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        if (sessionStorage.getItem("userLogin")) {
          return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
        } else {
          return null;
        }
      }
    },
    $currentUserData() {
      return JSON.parse(sessionStorage.getItem("userLogin"));
    }
  }
};
